export default {
  categoriesLabel: 'Kategorien',
  emojiUnsupportedMessage: 'Dein Browser unterstützt keine farbigen Emojis.',
  favoritesLabel: 'Favoriten',
  loadingMessage: 'Wird geladen…',
  networkErrorMessage: 'Konnte Emoji nicht laden.',
  regionLabel: 'Emoji auswählen',
  searchDescription: 'Wenn Suchergebnisse verfügbar sind, wähle sie mit Pfeil rauf und runter, dann Eingabetaste, aus.',
  searchLabel: 'Suchen',
  searchResultsLabel: 'Suchergebnisse',
  skinToneDescription: 'Wenn angezeigt, nutze Pfeiltasten rauf und runter zum Auswählen, Eingabe zum Akzeptieren.',
  skinToneLabel: 'Wähle einen Hautton (aktuell {skinTone})',
  skinTonesLabel: 'Hauttöne',
  skinTones: [
    'Standard',
    'Hell',
    'Mittel-hell',
    'Mittel',
    'Mittel-dunkel',
    'Dunkel'
  ],
  categories: {
    custom: 'Benutzerdefiniert',
    'smileys-emotion': 'Smileys und Emoticons',
    'people-body': 'Menschen und Körper',
    'animals-nature': 'Tiere und Natur',
    'food-drink': 'Essen und Trinken',
    'travel-places': 'Reisen und Orte',
    activities: 'Aktivitäten',
    objects: 'Objekte',
    symbols: 'Symbole',
    flags: 'Flaggen'
  }
}
